import ErrorReporter from 'scripts/infrastructure/error_reporter';
import { Unauthorized } from 'scripts/application/lib/error';

/**
 * Abstract / template class for handling common gateway errors.
 */
export default class GatewayErrorHandler {
  /**
   * Handles typical errors occurring when communicating with a remote service via a gateway.
   *
   * @param ctx - request context for reporting unknown errors to Sentry
   * @param err - the error to handle
   */
  handleCommonErrors(ctx, err) {
    if (arguments.length === 1 || !err) {
      err = arguments[0];
    }

    if (err instanceof Unauthorized) {
      this.handleUnauthorized(ctx, err);
    } else {
      this.handleInfrastructureErrors(ctx, err);
    }
  }

  reportError({ correlationId }, err) {
    if (arguments.length === 1 || !err) {
      err = arguments[0];
      correlationId = err.correlationId;
    }

    const causeStack = err.stack;
    err.stack = new Error().stack; // update error stack trace to retain observer stack trace
    ErrorReporter.reportError(err, { extra: { correlationId, ...err, causeStack } });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/lib/gateway_error_handler.js